import { endpoints, type NotificationSubscription } from '@gopinhos/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../lib/api-client';

interface SubscriptionsResponse {
  items: NotificationSubscription[];
}

export function useNotificationSubscriptions() {
  return useQuery({
    queryKey: ['notification-subscriptions'],
    queryFn: () =>
      apiClient.request<unknown, never>({
        method: 'GET',
        path: endpoints.notificationSubscriptions(),
      }) as Promise<SubscriptionsResponse>,
  });
}

export function useUpdateNotificationSubscriptions() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (items: NotificationSubscription[]) =>
      apiClient.request({
        method: 'PUT',
        path: endpoints.notificationSubscriptions(),
        body: { items },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['notification-subscriptions'] });
    },
  });
}
